export default function none<T>(
  items: T[],
  predicate: (item: T) => boolean = () => true,
) {
  return !items.some((item) => predicate(item));
}
